import react, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import SingleSpot from "./SingleSpot/SingleSpot";
import UserAccessManagerListModal from "./SingleSpot/UserAccessManager/UserAccessManagerListModal";
import { Puff } from "react-loading-icons";
import "./NightspotLista.css";
import { AuthContext } from "../../../../Context/AppContext";
import NightspotRequests from "../NightspotRequests.js";
import SpotModal from "./SingleSpot/SpotModal.jsx";
import ModalPlans from "../../Billing/Plans/Plans";
import { Button } from "react-bootstrap";
import ModalPayment from "../../Billing/Plans/ModalPayment";
import ModalSponsorVenues from "./Sponsor/ModalSponsorVenues";
import NavBar from "../../../../components/NavBar.jsx";

const NightspotsList = () => {
  const { userInfo } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [listData, setListData] = useState({
    list: [],
  });
  const [state, setState] = useState({
    modalPlans: {
      show: false,
      id_venues: 0,
      id_events: 0,
    },
    modalPayment: {
      show: false,
      value: "",
    },
    modalSponsorVenues: {
      show: false,
      id_venues: 0,
      venue_name: "",
    },
  });
  const [modalUsersAccess, setModalUsersAccess] = useState({
    isVisible: false,
    id: 0,
  });

  const [modalCreateSpot, setModalCreateSpot] = useState(false);
  const handleShowModalCreateSpot = () => setModalCreateSpot(true);
  const handleHideModalCreateSpot = () => setModalCreateSpot(false);

  const handleShowModalUserAccess = (id) => {
    setModalUsersAccess({
      isVisible: true,
      id: id,
    });
  };
  const handleHideModalUserAccess = () => {
    setModalUsersAccess({
      isVisible: false,
      id: 0,
    });
  };

  const requestVenuesList = async () => {
    setIsLoading(true);
    let info = await NightspotRequests.getListNightspot();
    if (info && info.status) {
      setListData({ list: info.data });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    document.title = "Os meus Spots | Nightspot";
    requestVenuesList();
  }, []);

  const MagicAddCard = () => (
    <div className="col-12 col-md-6 mb-4">
      <div className="box-venue magic-add-card text-center d-flex flex-column align-items-center justify-content-center py-5">
        <div className="mb-3">
          <i className="fa-solid fa-circle-plus fs-1 text-primary"></i>
        </div>
        <h4 className="fw-bold text-white">Adicionar Novo Spot</h4>
        <p className="text-muted small px-5 mb-4">
          Regista o teu estabelecimento para começares a gerir eventos e reservas.
        </p>
        <button onClick={handleShowModalCreateSpot} className="btn btn-action btn-action-primary px-4 rounded-pill w-auto">
          Começar Agora
        </button>
      </div>
    </div>
  );

  const ListaNightSpots = () => {
    if (listData.list.length === 0) {
      return <div className="col-12"><NoResults /></div>;
    }

    return (
      <div className="row">
        <MagicAddCard />
        {listData.list.map((item, index) => (
          <SingleSpot
            key={index}
            data={item}
            showUsersAccess={(id) => handleShowModalUserAccess(id)}
            showPaymentInfo={(value) =>
              setState({
                ...state,
                modalPayment: {
                  ...state.modalPayment,
                  show: true,
                  value: value,
                },
              })
            }
            handlerSponsorVenue={(item) =>
              setState({
                ...state,
                modalSponsorVenues: {
                  ...state.modalSponsorVenues,
                  show: true,
                  id_venues: item.id,
                  venue_name: item.name,
                },
              })
            }
          />
        ))}
      </div>
    );
  };

  const NoResults = () => (
    <div className="empty-state-wrapper text-center">
      <div className="empty-state-hero mb-5">
        <p className="empty-hero-subtitle">
          Transforma o modo como geres os teus espaços e eventos com a Nightspot.
        </p>
      </div>

      <div className="empty-steps-grid row justify-content-center">
        <div className="col-12 col-md-4 mb-4 mb-md-0">
          <div className="step-card completed">
            <div className="step-badge"><i className="fa-solid fa-check"></i></div>
            <h4>Registo Efetuado</h4>
            <p>Já fazes parte da maior rede de gestão de eventos.</p>
          </div>
        </div>

        <div className="col-12 col-md-4 mb-4 mb-md-0">
          <div className="step-card active">
            <div className="step-badge">2</div>
            <h4>Cria o teu Spot</h4>
            <p>Adiciona o teu estabelecimento para começares a faturar.</p>
            <button onClick={handleShowModalCreateSpot} className="btn-step-action mt-3">
              Criar Agora
            </button>
          </div>
        </div>

        <div className="col-12 col-md-4">
          <div className="step-card pending">
            <div className="step-badge">3</div>
            <h4>Lança Eventos</h4>
            <p>Ativa o teu calendário e começa a gerir os teus eventos.</p>
          </div>
        </div>
      </div>
    </div>
  );


  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" />
      <span className="mt-3 text-muted">A carregar os teus spots...</span>
    </div>
  );

  return (
    <NavBar>
      <div className="py-4 dashboard-content">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb premium-breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/my/dashboard">
                <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item active">Os teus Spots</li>
          </ol>
        </nav>

        <div className="row mb-2">

          <div className="col-12">
            <h1 className="nightspots-section-title">Os teus Spots</h1>
            <p className="nightspots-section-subtitle">Gere os teus estabelecimentos, equipas e acessos.</p>
          </div>
        </div>

        {isLoading ? <InsideLoading /> : <ListaNightSpots />}

        <SpotModal
          show={modalCreateSpot}
          handleModalhide={handleHideModalCreateSpot}
        />
        <UserAccessManagerListModal
          show={modalUsersAccess.isVisible}
          id={modalUsersAccess.id}
          handleModalhide={handleHideModalUserAccess}
          handleModalShow={(id) => handleShowModalUserAccess(id)}
        />
        <ModalPlans
          show={state.modalPlans.show}
          data={state.modalPlans}
          handleModalhide={() =>
            setState({
              ...state,
              modalPlans: { ...state.modalPlans, show: false },
            })
          }
          handlerSubmitPlan={(plan) => navigate(`/my/nightspots/create/${plan}`)}
        />
        <ModalSponsorVenues
          show={state.modalSponsorVenues.show}
          data={state.modalSponsorVenues}
          handleModalhide={() => {
            setState({
              ...state,
              modalSponsorVenues: { ...state.modalSponsorVenues, show: false },
            });
            requestVenuesList();
          }}
          handlerBillingPlans={() =>
            setState({
              ...state,
              modalSponsorVenues: { ...state.modalSponsorVenues, show: false },
              modalPlans: { ...state.modalPlans, show: true },
            })
          }
        />
      </div>
    </NavBar>
  );
};

export default NightspotsList;
